import { Image } from '@components/common/Image';
import styles from './index.module.css';

export const Printable = () => (
  <div className={styles.container}>
    <p className={styles.text}>
      Choose your Plan and get your <span>Printable Guide</span>
    </p>
    <Image
      height={105}
      width={98}
      src="printable.webp"
      alt="printable"
      style={{ objectFit: 'contain', marginTop: 10 }}
    />
  </div>
);
